module.exports = __webpack_public_path__ + "img/straps_length.7bb1e84e.png";